import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * Spanish DNI validator following Single Responsibility Principle
 */
export class EsValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Spanish DNI',
      pattern: /^\d{8}[A-Z]$/i,
      length: 9
    });
  }

  validateFormat(id) {
    const upperCaseId = id.toUpperCase();
    
    // Check length
    const lengthValidation = this.validateLength(upperCaseId, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      upperCaseId,
      this.config.pattern,
      'Spanish DNI format must be 8 digits followed by a letter'
    );
  }

  validateChecksum(id) {
    const upperCaseId = id.toUpperCase();
    const letters = 'TRWAGMYFPDXBNJZSQVHLCKE';
    const digits = upperCaseId.substring(0, 8);
    const expectedLetter = letters[parseInt(digits) % 23];
    const actualLetter = upperCaseId[8];

    if (expectedLetter !== actualLetter) {
      return ValidationResult.invalid(`Invalid Spanish DNI checksum. Expected: ${expectedLetter}, Got: ${actualLetter}`);
    }

    return ValidationResult.valid('Valid Spanish DNI');
  }
}